import isMobile from '@anm/helpers/is/isMobile';
import noop from '@anm/helpers/noop';
import { ChangeEvent, FC } from 'react';

import {
  AddChannelButton,
  ChannelIdInput,
  InputRow,
  TooltipWrapper
} from './Wrapper';

type ChannelInputWithButtonProps = {
  inputText: string;
  canShowTooltip: boolean;
  isButtonDisabled: boolean;
  onAddChannel(): void;
  onInputChange(evt: ChangeEvent<HTMLInputElement>): void;
  renderTooltip(): JSX.Element;
};

const ChannelInputWithButton: FC<ChannelInputWithButtonProps> = ({
  inputText,
  canShowTooltip,
  isButtonDisabled,
  onAddChannel,
  renderTooltip,
  onInputChange
}) => (
  <InputRow>
    <ChannelIdInput
      placeholder="YouTube Channel ID"
      value={inputText}
      onChange={onInputChange}
    />
    <TooltipWrapper
      delayShow={300}
      delayHide={300}
      direction={isMobile() ? 'to-bottom' : 'to-right'}
      renderContent={canShowTooltip ? renderTooltip : undefined}
    >
      <AddChannelButton
        size="large"
        variant="blue-heavy-border"
        disabled={isButtonDisabled}
        isButtonDisabled={isButtonDisabled}
        onClick={canShowTooltip ? noop : onAddChannel}
      >
        Add
      </AddChannelButton>
    </TooltipWrapper>
  </InputRow>
);

export default ChannelInputWithButton;
